module.exports = __webpack_public_path__ + "img/close.6972a731.svg";